export const logged = ({ auth }) => auth.isAuthorized;

export const currentUser = ({ auth }) => auth.user;

export const isAdmin = ({ auth }) => auth.user.groups ? auth.user.groups.find(el => el === 'admin') : null;

export const isFetch = ({ auth }) => auth.user.groups ? auth.user.groups.find(el => el === 'fetch') : null;
